module.exports = __webpack_public_path__ + "static/img/5.cc434ea1.png";